import { tutorialResolver } from './tutorial'
import { tutorialsResolver } from './tutorials'

import { updateMultipleTutorial } from './update-multiple-tutorial'
import { deleteTutorials } from './delete-tutorials'

export const Query = {
  ...tutorialsResolver,
  ...tutorialResolver
}

export const Mutation = {
  ...updateMultipleTutorial,
  ...deleteTutorials
}
